import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        Test
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          This is a test application
        </p>
      </header>
    </div>
  );
}

export default App;
